export default __webpack_public_path__ + "static/media/element_79.ce629f7b.webp";